import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import * as pageData from "./PageData";

var myVar = null;
var answers = pageData.abstractReasoningAnswers;

const underway = 0;
const promptIncomplete = 1;
const promptMoreTime = 2;

export default class AbstractReasoning extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
        this.handleModalProceed = this.handleModalProceed.bind(this);
        this.handleModalReturn = this.handleModalReturn.bind(this);

        const arr = [];

        for (let i = 0; i < pageData.abstractReasoningTestPages; i++) {
            arr.push(pageData.nullOption);
        }

        this.state = {
            memory: arr,
            secondsRemaining: 1200,
            completedState: underway
        };
    }

    componentDidMount() {
        this.afterUpdate();

        myVar = setInterval(this.updateTimer.bind(this), 1000);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    updateTimer() {
        const secondsRemaining = this.state.secondsRemaining;

        try {
            if (secondsRemaining > 0) {
                this.setState({ secondsRemaining: secondsRemaining - 1});
            } else {
                clearTimeout(myVar);
                this.setSkipResponse();
            }
        } catch (e) {
            clearTimeout(myVar);
        }
    }

    optionChange(value) {
        const arr = this.state.memory;

        arr[this.props.index] = value;

        this.setState({ memory: arr });
    }

    handleModalProceed() {
        if (this.state.completedState === promptIncomplete) {
            /*this.setSkipResponse();*/
            this.setResponse();
        } else {
            this.setResponse();
        }
    }

    handleModalReturn() {
        this.setState({ completedState: underway });
    }

    setSkipResponse() {
        this.props.next({ response: pageData.skipRemaining });
    }

    setResponse() {
        let response = this.state.memory[this.props.index];

        var check1 = pageData.nullOption;
        var check2 = answers[this.props.index];

        if (response !== check1 && response !== check2) {
            response *= -1;
        }

        this.props.next({ response: response });
    }

    interceptClick(type) {
        if (type === "next") {
            this.setResponse();
            return true;
        }
        else if (type === "back") {
            let response = this.state.memory[this.props.index];

            if (response == null || response == pageData.nullOption)
            {
                return false;
            }

            if (response !== pageData.nullOption && response !== answers[this.props.index]) {
                response *= -1;
            }

            this.props.previous({ response: response });
            return false;
        }
        else if (type === "prev") {
            clearTimeout(myVar);
        }
        else if (type === "end") {
            const count = this.state.memory.reduce((accumulator, currentValue) => accumulator + (currentValue === pageData.nullOption ? 1 : 0), 0);

            if (count === 0) {
                this.setState({ completedState: promptMoreTime });
            } else {
                this.setState({ completedState: promptIncomplete });
            }
        }

        return false;
    }

    render() {
        const p = this.props;
        const optionChange = this.optionChange;
        const handleModalReturn = this.handleModalReturn;
        const handleModalProceed = this.handleModalProceed;

        const progressStyle = {
            width: `${p.index * (100 / pageData.abstractReasoningTestPages)}%`
        };

        return (
            <div className="test-page-content-inner test-page-abstract-reasoning">
                <div className="test-content">
                    {renderPractice(p, this.state, optionChange, handleModalReturn, handleModalProceed)}
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, optionChange, handleModalReturn, handleModalProceed) {
    const sourceIndex = props.index;
    const src = `/images/abstract-reasoning/${sourceIndex + 1}.jpg`;
    const time = pageData.secondsToTime(state.secondsRemaining);

    return (
        <div className="test-content-inner">
            <div className="image">
                <img alt="" src={src} height="300px" />
            </div>
            {renderTimer(time)}
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOption(props, state, sourceIndex, 1, optionChange)}
                {renderOption(props, state, sourceIndex, 2, optionChange)}
                {renderOption(props, state, sourceIndex, 3, optionChange)}
                {renderOption(props, state, sourceIndex, 4, optionChange)}
                {renderOption(props, state, sourceIndex, 5, optionChange)}
                {renderOption(props, state, sourceIndex, 6, optionChange)}
            </div>
            {renderIncompleteModal(state, time, handleModalReturn, handleModalProceed)}
        </div>
    );
}

function renderIncompleteModal(state, time, handleModalReturn, handleModalProceed) {
    return (
        <Modal show={(state.completedState > underway)}>
            <Modal.Header>
                <Modal.Title>End Test</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderModalMessage(state, time)}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="default" onClick={handleModalReturn}>No thanks</Button>
                <Button bsStyle="success" onClick={handleModalProceed}>Yes, I'm sure</Button>
            </Modal.Footer>
        </Modal>
        );
}

function renderModalMessage(state, time) {
    if (state.completedState === promptIncomplete) {
        return (
         <div>Are you certain that you want to end the test without answering all the questions?</div>   
            );
    }

    return (
        <div>You still have {time} left. Are you sure you want to end the test?</div>
    );
}

function renderTimer(time) {
    return (
<div className="timer">
    <div className="timer-title">Time remaining:</div>
    <div className="timer-value">{time}</div>
</div>
        );
}

function renderOption(props, state, sourceIndex, optionValue, optionChange) {
    const key = `option${sourceIndex}-${optionValue}`;
    const checked = state.memory[sourceIndex] === optionValue ? "checked" : "";
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    const src = `/images/abstract-reasoning/${sourceIndex + 1}-${optionValue}.jpg`;

    return (
        <div key={key} onClick={() => optionChange(optionValue)} className={checked} disabled={disabled}><img alt="" src={src} /></div>
    );
}
